import { lazy } from "react";
import { MODULE_IDS } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { app_navbar_routes } from "../../constants/app-navbar-routes";

//************************ Purchase Order Imports ***************************/
const MaterialRequestList = Loadable(
  lazy(() =>
    import("./MaterialRequestList").then(({ MaterialRequestList }) => ({
      default: MaterialRequestList,
    })),
  ),
);

//************************ Purchase Order Routes ***************************/
export const materialRequestRoutes = [
  {
    path: app_navbar_routes.app.material_request,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.MATERIAL_REQUEST]}>
        <MaterialRequestList />
      </AuthorizedRoute>
    ),
  },
  {
    path: app_navbar_routes.app.material_allocation.mr_wise,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.MATERIAL_REQUEST]}>
        <MaterialRequestList viewType={"MR_APPROVED"} />
      </AuthorizedRoute>
    ),
  },
  {
    path: app_navbar_routes.app.approvals.material_request,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.APPROVAL_MATERIAL_REQUEST]}>
        <MaterialRequestList viewType={"APPROVAL"} />
      </AuthorizedRoute>
    ),
  },
];
